import React from 'react';
import styled from '@emotion/styled';

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
`;
const SectionTitle = styled.h2`
  font-size: 32px;
  margin: 30px 0;
  text-align: center;
  color: ${props => props.theme.colors.black.base};
`;
const SectionDescription = styled.p`
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  font-family: ${props => props.theme.fontFamily.body};
  color: ${props => props.theme.colors.black.light};
  max-width: 600px;
  margin-bottom: 40px;
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;

  @media (min-width: ${props => props.theme.breakpoints.s}) and (max-width: ${props => props.theme.breakpoints.m}) {
    width: 90%;
  }

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    width: 95%;
  }
`;
const Columns = styled.div`
  display: flex;
  flex-direction: row;
  margin-top:20px;
  width: 100%;

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;
const Column = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0 20px;
  max-width: 400px;

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    min-width: 360px;
  }
`;
const ColumnTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  font-family: ${props => props.theme.fontFamily.body};
  color: ${props => props.highlightText ? props.theme.colors.primary.base : props.theme.colors.black.base};
`;
const ColumnText = styled.p`
  font-size: 12px;
  line-height: 24px;
  margin-top:15px;
  color: ${props => props.theme.colors.black.base};

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    text-align: center;
  }
`;
const FooterText = styled.p`
  font-size: 13px;
  color: ${props => props.theme.colors.black.base};
  margin-top: 40px;
  font-weight: 500;
`;
const MultiColumnContent = props => {
  const { title, description, content, footerText } = props.content ? props.content : {};
  const items = content ? content : []
  const itemsInGroup = props.itemsInGroup
  const itemsRows = chunkArrayInGroups(items, itemsInGroup ? itemsInGroup : 3)
  return (
    <Section>
      <ContentWrapper>
        {title ? title.split('\n').length > 1 ? (
          <SectionTitle>
            {title.split('\n').map((item, key) => (<span key={key}>{item}<br /></span>))}
          </SectionTitle>

        ) : (
            <SectionTitle>{title}</SectionTitle>
          ) : null}
        {description ? (
          <SectionDescription>{description}</SectionDescription>
        ) : null}
        {itemsRows.map((items, rowIdx) => {
          return (
            <Columns key={`row_${rowIdx}`}>
              {items.map((contentCol, idx) => {
                return (
                  <Column key={idx}>
                    <ColumnTitle highlightText={props.highlightColumnTitle}>{contentCol.title}</ColumnTitle>
                    <ColumnText>{contentCol.description}</ColumnText>
                  </Column>
                )
              })}
            </Columns>
          )
        })}
        {footerText ? (
          <FooterText>{footerText}</FooterText>
        ) : null}
      </ContentWrapper>
    </Section>
  );
};

const chunkArrayInGroups = (arr, size) => {
  let groups = [];
  for (let i = 0; i < arr.length; i += size) {
    groups.push(arr.slice(i, i + size));
  }
  return groups;
}

export default MultiColumnContent;
